import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { Conversation } from '../interfaces/conversation';
import { Pagination } from '../interfaces/pagination';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getConversations(
    page: number,
    size: number,
    inventory: number,
    searchValue: string,
    isAssistanceRequired: string
  ): Promise<{ conversations: Conversation[]; pagination: Pagination }> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/chats', {
        params: {
          page: page,
          size: size,
          inventory: inventory,
          searchValue: searchValue,
          assistance: isAssistanceRequired,
        },
      })
    );
  }

  getTotalAssistanceRequired(inventory: number): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/chats/total-assistance-required', {
        params: {
          inventory: inventory,
        },
      })
    );
  }

  getConversationHistoryById(
    conversationId: string,
    page: number,
    size: number
  ): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/chat/' + conversationId, {
        params: {
          page: page,
          size: size,
        },
      })
    );
  }
  getConversationHistoryByPhone(
    phone: string,
    page: number,
    size: number
  ): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/messages/phone/' + phone, {
        params: {
          page: page,
          size: size,
        },
      })
    );
  }
  validateChatToken(token: any): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(this.baseUrl + 'chat-token/validate', {
        token: token,
      })
    );
  }

  updateConversation(id: string): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/update/' + id)
    );
  }
  getAiBotStatus(phone: string): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/bot-status', {
        params: { phone: phone },
      })
    );
  }
  sendMessages(conversationId: string, message: string): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(this.baseUrl + 'gpt/send-message', {
        conversationId: conversationId,
        message: message,
      })
    );
  }
  setAiBotStatus(phone: string, botEnabled: boolean): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(this.baseUrl + 'gpt/bot-status', {
        phone: phone,
        botEnabled: botEnabled,
      })
    );
  }

  getDetailCustomer(id: number | null): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/customer/' + id)
    );
  }
  getDetailAddressUser(phone: string): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/user-address/' + phone)
    );
  }
  getDesign(): Promise<any> {
    return firstValueFrom(this.http.get<any>(this.baseUrl + 'gpt/design'));
  }
  getStoreInfo(): Promise<{ name: string | null; urlStore: string | null }> {
    return firstValueFrom(this.http.get<any>(this.baseUrl + 'gpt/store-info'));
  }
  getFlowEntities(
    productIds: string[],
    extraIds: string[]
  ): Promise<{
    products: { id: string; name: string; image: string | null; price: number }[];
    extras: { id: string; name: string; price: number }[];
  }> {
    return firstValueFrom(
      this.http.get<any>(this.baseUrl + 'gpt/flow-entities', {
        params: {
          products: productIds.join(','),
          extras: extraIds.join(','),
        },
      })
    );
  }
  conversationAssistantReady(
    conversationId: string,
    phone: string,
    isAssistanceRequired: boolean
  ): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(this.baseUrl + 'gpt/assistant-ready', {
        phone: phone,
        conversationId: conversationId,
        isAssistanceRequired: isAssistanceRequired,
      })
    );
  }
  getImageMessage(messageId: string, conversationId: string): Promise<any> {
    return firstValueFrom(
      this.http.get<any>(
        this.baseUrl + 'gpt/image/' + conversationId + '/' + messageId
      )
    );
  }
}
